import React from 'react'
import { useAppConfig } from '../'
import type { Account } from '../../core'
import getAccountDisplayName from '../utils/AccountDisplayName'

export const useAccountDisplayName = (account: Account) => {
  const { config } = useAppConfig()
  return React.useMemo(
    () =>
      getAccountDisplayName(account, {
        allowNickname: config?.show_account_nicknames_in_master,
      }),
    [account, config?.show_account_nicknames_in_master],
  )
}

export default useAccountDisplayName
